import { render, staticRenderFns } from "./FDDataMng.vue?vue&type=template&id=3b945595&style=height%3A%20100%25%3B"
import script from "./FDDataMng.vue?vue&type=script&lang=js"
export * from "./FDDataMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports